<style lang="scss" scoped>
  @import '../../../sass/variables';

  $activities-themes:
    'delayed' #FF1E1E $white,
    'today' $salesflow-secondary #212529,
    'all' $salesflow-purple-medium $white;

  @each $theme in $activities-themes {
    .badge-activities-#{nth($theme, 1)} {
      min-width: 18px;
      min-height: 18px;
      color: nth($theme, 3);
      background-color: nth($theme, 2);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 0%;
      font-weight: 700;
      letter-spacing: -0.18px;
      border-radius: 100%;
    }
  }

  .gap-1 {
    gap: 4px;
  }

  .gap-3 {
    gap: 12px;
  }

  .activities-sidebar {
    padding: 0px 0px 0px 32px;
    .activities-sidebar-content {
      background-color: $white;
      padding: 4px;
      height: 100%;
      border: 1px solid $salesflow-outline-gray-medium;
      border-radius: 16px;
    }
  }

  .page-schedule-link {
    color: $salesflow-font-gray;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    padding-bottom: 8px;
    
    &:hover {
      text-decoration: none;
    }

    &.active {
      color: $salesflow-purple-medium;
      font-weight: 700;
      border-bottom: 2px solid $salesflow-purple-medium;
    }
  }

  h4 {
    text-align: center;
    color: $salesflow-font-gray;
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 600;
    font-size: 20px;
    line-height: 150%;
    margin: 16px auto 32px;
  }

  input[type=radio], input[type=checkbox] {
    display:none; /* Esconde os inputs */
  }

  label {
    cursor: pointer;
  }

  input[type="radio"] + label:before, input[type="checkbox"] + label:before {
    border: 1px solid $salesflow-outline-gray-medium;
    content: "\00a0";
    display: inline-block;
    font: 20px/1em sans-serif;
    height: 20px;
    margin: 0 12px 0 0;
    padding:0;
    vertical-align: top;
    width: 20px;
    border-radius: 10px;
  }

  input[type="radio"]:checked + label:before, input[type="checkbox"]:checked + label:before {
    background:  $purple;
    color: $white-gray-2;
    content: "\2713";
    text-align: center;
  }

  input[type="radio"]:checked + label:after, input[type="checkbox"]:checked + label:after {
    font-weight: bold;
  }

  .activity-text-color {
    color:  $salesflow-font-gray;
  }

  .list-left {
    float: left;
    i {
      font-size: 18px;
      margin-right: 8px;
      width: 21px;
    }
  }

  .black-text-color {
    color: $salesflow-font-dark !important;
  }

  .activities-list {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: $salesflow-font-dark;

    .list-right {
      line-height: 1.5;
    }

    span.activity-date-text {
      font-weight: 700;
      color: $salesflow-purple-medium;
      &.danger {
        color: $salesflow-outline-gray-medium;
      }
    }
  }

  .checked {
    text-decoration: line-through;
  }

  .flex-wrap {
    row-gap: 14px;
  }
</style>

<template>
  <div>
    <div class="row">
      <div class="col-12 ml-3 d-flex align-items-center">
        <h2 class="page-subtitle">
          <span v-if="today.length > 0">
            {{ __('Você possui') }}
            <strong v-if="today.length === 1">{{ today.length }} {{ __('atividade') }}</strong>
            <strong v-else>{{ today.length }} {{ __('atividades') }}</strong>
            {{ __('para hoje') }}
          </span>
          <span v-else>
            {{ __('Você não tem atividades para hoje') }}
          </span>
        </h2>
        <div class="ml-auto mr-3">
          <InputDropdown
            v-if="users.length"
            :items="users"
            :selected="user_name || __('Usuário')"
            @select="(user) => setUser(user)"
          />
        </div>
      </div>
    </div>
    <div
      id="calendar"
      class="pt-3"
    >
      <div class="row board mt-0 p-3 pb-48px bg-salesflow-bg-content">
        <div class="col-md-9 bg-salesflow-bg-content p-0 table-borderless calendar-container hidden-sm hidden-xs">
          <div v-fullcalendar="fullcalendar" />
        </div>
        <div class="activities-sidebar col-md-3">
          <div class="activities-sidebar-content">
            <h4>
              {{ __('Atividades') }}
            </h4>
            <div
              v-show="! loading"
              class="w-100 d-flex align-items-center justify-content-center mt-3 mb-32px gap-3 flex-wrap"
            >
              <a
                :class="['page-schedule-link d-flex align-items-center justify-content-center', { active: selected === 'today' }]"
                href="#"
                @click.prevent="select('today')"
              >
                <div class="d-flex align-items-center justify-content-center px-2px gap-1">
                  <span class="label">{{ __('Hoje') }}</span>
                  <span class="badge badge-activities-today">{{ today.length }}</span>
                </div>
              </a>

              <a
                :class="['page-schedule-link d-flex align-items-center justify-content-center', { active: selected === 'delayed' }]"
                href="#"
                @click.prevent="select('delayed')"
              >
                <div class="d-flex align-items-center justify-content-center px-2px gap-1">
                  <span class="label">{{ __('Atrasadas') }}</span>
                  <span class="badge badge-activities-delayed">{{ delayed.length }}</span>
                </div>
              </a>

              <a
                :class="['page-schedule-link d-flex align-items-center justify-content-center', { active: selected === 'all' }]"
                href="#"
                @click.prevent="select('all')"
              >
                <div class="d-flex align-items-center justify-content-center px-2px gap-1">
                  <span class="label">{{ __('Todas') }}</span>
                  <span class="badge badge-activities-all">{{ all.length }}</span>
                </div>
              </a>
            </div>
            <ActivityList
              v-if="!loadingActivities && activities.length > 0"
              :activities="filtered"
              @activityCompleted="refreshCalendar"
            />
            <div v-else-if="loadingActivities">
              <div class="text-center">
                <i class="fa fa-circle-o-notch fa-spin" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DealModal
      v-if="user && pipelines"
      :user="user"
      :pipelines="pipelines"
    />
    <DealOpenReasonModal />
    <DealLostReasonModal />
    <DealWonReasonModal />
  </div>
</template>

<script>
import { Alert } from '../../services/alert.js';
import ScheduleModal from '../ScheduleModal.vue';
import jQuery from 'jquery';
import dayjs from '../../core/dayjs.js';
import Swal from 'sweetalert2';
import DealOpenReasonModal from '../deal/ReasonModal/DealOpen/DealOpenReasonModal.vue';
import DealLostReasonModal from '../deal/ReasonModal/DealLost/DealLostReasonModal.vue';
import DealWonReasonModal from '../deal/ReasonModal/DealWon/DealWonReasonModal.vue';

window.$ = window.jQuery = jQuery;

export default {
  props: ['can', 'user'],
  store: ['users'],
  components: {
    DealOpenReasonModal,
    DealLostReasonModal,
    DealWonReasonModal,
  },
  data () {
    return {
      modalVM: null,
      pipelines: [],
      fromUser: '',
      loading: true,
      loadingActivities: false,
      activities: [],
      filtered: [],
      selected: '',
      fullcalendar: {},
      typeNames: {
        delayed: 'Atrasadas',
        today: 'Hoje',
        all: 'Todas',
      },
      user_name: '',
      showModal: false,
      selectedActivity: null,
      modalTimeout: null,
      modalPosition: { x: 0, y: 0 }, 
      isHovering: false,
    };
  },
  computed: {
    limitedActivities () {
      return this.filtered.slice(0, 75);
    },
    delayed () {
      return this.activities.filter((activity) => {
        const now = new Date();
        const scheduled = new Date(activity.scheduled_at);
        if (scheduled.getTime() < now.getTime() && !activity.completed_at) {
          return true;
        }
        return false;
      });
    },
    today () {
      return this.activities.filter((activity) => {
        const now = new Date();
        const scheduled = new Date(activity.scheduled_at);
        if (scheduled.setHours(0, 0, 0, 0) == now.setHours(0, 0, 0, 0)) {
          return true;
        }
        return false;
      });
    },
    all () {
      return this.activities;
    },
  },
  mounted () {
    this.getPipelines();
    this.refreshCalendar();

    Bus.$on('activityCompleted', (activity) => {
      this.refreshCalendar();
    });

    Bus.$on('markCardAs', (data) => {
      const card = data[0];
      const status = data[1];

      this.markAs(card, status);
    });

    Bus.$on('askShouldCreateAnotherDeal', (card) => this.askShouldCreateAnotherDeal(card));
  },
  methods: {
    askShouldCreateAnotherDeal (card) {
      Swal.fire({
        html:`<div class="swal2-title">${this.__('Deseja criar um <br> novo negócio?')}</div>`
              + '<div><img src="/build/images/deal/create-new-deal-image.svg"></div>',
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Sim'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Não'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2 custom-create-new-deal',
          confirmButton: 'salesflow-btn salesflow-btn-create-new-deal',
          cancelButton: 'btn swal2-btn-cancel-transparent',
        },
        willClose: () => {
          setTimeout(() => {
            Bus.$emit('close');
          }, 500);
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          Bus.$emit('createDealButtonToggled', [card.lead, card]);
        }
      });
    },
    markAs (card, status) {
      const old = card.status;

      if (status == 'lost' || status == 'closed' || status == 'open') {
        if (old === status) {
          return;
        }

        return this.ask(card, old, status);
      }

      this.updateStatus(card, status);
    },
    ask (card, _, status) {
      if (status === 'lost') {
        Bus.$emit('openDealLostReasonModal', card)
      } else if (status === 'closed') {
        Bus.$emit('openDealWonReasonModal', card)
      } else if (status == 'open') {
        Bus.$emit('show-open-observation-modal', card);
      }
    },
    updateStatus (card, status) {
      this.loading = true;

      this.$http.put(`/deal/${card.id}`, { status })
        .then((response) => {
          card = response.data;
        })
        .catch((error) => {
          Alert.error(this.__('Erro ao atualizar status do negócio'));
          console.error('Error updating deal status:', error);
        });
    },
    mountModal(activity, position) {
      if (this.modalVM) {
        this.modalVM.$destroy();
        this.modalVM.$el.remove();
        this.modalVM = null;
      }

      const ModalConstructor = Vue.extend(ScheduleModal);
      const container = document.createElement('div');
      document.body.appendChild(container);

      const self = this;

      this.modalVM = new ModalConstructor({
        propsData: {
          show: true,
          activity,
          position
        }
      });

      this.modalVM.$on('close', () => {
        self.modalVM.$destroy();
        self.modalVM.$el.remove();
        self.modalVM = null;
      });

      this.modalVM.$on('activityCompleted', () => {
        self.refreshCalendar();
      });

      this.modalVM.$on('mouseenters', () => {
        self.cancelCloseModal();
      });

      this.modalVM.$on('mouseleaves', () => {
        self.closeModal();
      });

      this.modalVM.$mount(container);
    },

    openModal(activityElement, activity) {
      clearTimeout(this.modalTimeout);
      if (!activity || !activity.id) return;

      this.selectedActivity = activity;

      this.$nextTick(() => {
        if (!activityElement) return;

        const rect = activityElement.getBoundingClientRect();
        let posX = rect.right + 5;
        let posY = rect.top + window.scrollY;

        const windowWidth = window.innerWidth;
        const modalWidth = 300;

        if (posX + modalWidth > windowWidth) {
          posX = rect.left - modalWidth - 5;
        }

        const position = { x: posX, y: posY };
        this.mountModal(activity, position);
      });
    },

    closeModal() {
      clearTimeout(this.modalTimeout);

      this.modalTimeout = setTimeout(() => {
        const modalEl = document.querySelector('.modal-tooltip');
        const activityEl = document.querySelector(`[data-activity="${this.selectedActivity?.id}"]`);

        const hoveringModal = modalEl && modalEl.matches(':hover');
        const hoveringEvent = activityEl && activityEl.matches(':hover');

        if (hoveringModal || hoveringEvent) {
          return;
        }

        if (this.modalVM) {
          this.modalVM.$destroy();
          this.modalVM.$el.remove();
          this.modalVM = null;
        }

        this.showModal = false;
        this.selectedActivity = null;
      }, 200);
    },

    cancelCloseModal() {
      clearTimeout(this.modalTimeout);
    },

    getPipelines () {
      this.$http.get('/pipeline')
        .then((response) => {
          this.pipelines = response.data.pipelines;
        }).catch((error) => {
          console.log(error);
        });
    },

    getActivities (start = '', refresh = false) {
      this.loading = true;
      if (this.loadingActivities == true){
        return
      }
      this.loadingActivities = true;
      const url = `/calendar?ajax=true&user=${this.fromUser}&start=${start}`;
      this.$http.get(url)
        .then(response => {
          this.loading = false;
          this.activities = response.data.map(activity => ({
            id: activity.id,
            user_id: activity.user_id,
            lead_id: activity.lead_id,
            deal_id: activity.deal_id,
            lead_hashid: activity.lead_hashid,
            deal_hashid: activity.deal_hashid,
            type: activity.type,
            content: activity.content,
            data: activity.data,
            completed_status: activity.completed_status || null,
            scheduled_at: activity.scheduled_at,
            completed_at: activity.completed_at,
            created_at: activity.created_at,
            updated_at: activity.updated_at,
            deal: activity.deal ? { title: activity.deal.title || "Sem título" } : null,
            deal_data: activity.deal_data,
            lead: activity.lead ? {
              name: activity.lead.name || "Sem nome",
              email: activity.lead.email,
              phone: activity.lead.phone,
              city: activity.lead.city,
              state: activity.lead.state,
              country: activity.lead.country,
              document: activity.lead.document,
              company: activity.lead.company,
              occupation: activity.lead.occupation,
              gravatar: activity.lead.gravatar || "",
            } : null,
            user: {
              name: activity.user.name || "Sem nome",
              first_name: activity.user.first_name || "Sem nome",
              email: activity.user.email || "Sem email",
            },
            followers: Array.isArray(activity.followers)
              ? activity.followers.map(follower_name => ({
                  name: follower_name
                }))
              : [],
            attachments: activity.attachments ? { download_link: activity.attachments.download_link } : null,
            status: activity.completed_at ? 'Finalizado' : 'Pendente',
            summary: activity.summary || null,
            summary_updated_by: activity.summary_updated_by
              ? { id: activity.summary_updated_by.id, name: activity.summary_updated_by.name }
              : { id: null, name: null },
            sentiment: activity.sentiment || null,
            schedule_ends_at: activity.schedule_ends_at || activity.scheduled_at,
          }));
          this.select('today');

          if (refresh) {
            this.refreshCalendar();
          } else {
            this.refetchEvents();
          }
        })
        .catch(error => {
          console.error("❌ Erro ao buscar atividades:", error);
          this.loading = false;
        })
        .finally(() => {
          this.loadingActivities = false;
        });
    },

    refetchEvents () {
      this.fullcalendar = {
        refreshEvents: true,
        events: this.getEvents(),
      };
    },
    select (type) {
      this.selected = type;
      if (type === 'delayed') {
        this.filtered = this.delayed;
      } else if (type === 'today') {
        this.filtered = this.today;
      } else {
        this.filtered = this.all;
      }
    },
    refreshCalendar () {
      this.fullcalendar = {
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'month,agendaDay,listMonth',
        },
        locale: this.$lang().getLocale(),
        defaultview: 'month',
        defaultTimedEventDuration: '00:15',
        eventLimit: true,
        views: {
          agenda: {
            eventLimit: 10,
            allDaySlot: false,
          },
        },
        firstDay: 1,
        navLinks: true,
        // contentHeight: 650,
        eventMouseover: function(event, jsEvent) {
          const activityElement = jsEvent.currentTarget;
          const selectedActivity = this.activities.find(act => act.id === parseInt(event.id));
          if (selectedActivity) {
            this.openModal(activityElement, selectedActivity);
          }
        }.bind(this),
        eventMouseout: function(event) {
          this.closeModal();
        }.bind(this),
        viewRender: function (view) {
          this.getActivities(view.intervalStart.format());
        }.bind(this),
        eventClick: function (event) {
          const activity = this.activities.filter((activity) => activity.id == event.id).pop();
          if(activity.deal_id) {
            Bus.$emit('open', {
              ...activity.deal_data,
              lead: activity.lead,
            });
          } else {
            window.open(`/lead/${activity.lead_hashid}`);
          }
        }.bind(this),
        events: this.getEvents()
      };
    },
    getEvents () {
      return _.map(this.activities.filter((item) => {
        if (item.lead && item.user) {
          return item;
        }
      }), (item) => ({
        id: item.id,
        title: item.lead.name || item.lead.email,
        start: dayjs(item.scheduled_at).toDate(),
        end: null,
        color: this.getEventColor(item),
        textColor: this.getEventTextColor(item),
      }));
    },
    getEventColor (item) {
      if (item.completed_at) {
        return '#2ceba9';
      }
      const now = new Date();
      const scheduled = new Date(item.scheduled_at);

      if (scheduled.getTime() > now.getTime()) {
        if (scheduled.toDateString() === now.toDateString()) {
          return '#2CEBA9';
        }

        return '#7E5DF4';
      }

      return '#D1D1D1';
    },
    getEventTextColor (item) {
      const now = new Date();
      const scheduled = new Date(item.scheduled_at);

      if (scheduled.getTime() > now.getTime()) {
        if (scheduled.toDateString() === now.toDateString()) {
          return '#71767D'
        }

        return '#FFFFFF';
      }

      return '#71767D';
    },
    hasActivityDelayed (activity) {
      const today = new Date();
      const result = activity
            && activity.scheduled_at
            && (today.getTime() > new Date(activity.scheduled_at).getTime())
            && (! activity.completed_at);

      return result;
    },
    checkActivity (activity) {
      const { id } = activity;
      const params = {};
      for (const i in this.activities) {
        if (isNaN(i) || this.activities[i].id != id) {
          continue;
        }
        if (this.activities[i].completed_at) {
          this.activities[i].completed_at = null;
          params.uncheck = true;
        } else {
          this.activities[i].completed_at = new Date();
          params.complete = true;
        }
        activity = this.activities[i];
      }
      this.$http.put(`/lead/${activity.lead_hashid}/activity/${activity.id}`, params)
        .catch(() => {
          Alert.error(this.__('Erro ao atualizar atividade'));
        });
      this.refreshCalendar();
    },
    typeActivitiesImage (activityKey) {
      switch (activityKey) {
        case 'call':
          return '/build/icons/salesflow-phone-circle.svg';
        default:
          return '/build/icons/salesflow-phone-circle.svg';
      }
    },
    setUser (user) {
      this.fromUser = user.id;
      this.getActivities('', true);
      this.user_name = user.name;
    },
  },
};
</script>